import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import AdminGettingStarted from './sections/AdminGettingStarted'
import TravellerManagement from './sections/TravellerManagement'
import TravelPolicies from './sections/TravelPolicies'
import TravelApprovals from './sections/TravelApprovals'
import BookingManagement from './sections/BookingManagement'
import AdminGamification from './sections/AdminGamification'
import LoyaltyPrograms from './sections/LoyaltyPrograms'
import ReportingAndReconciliation from './sections/ReportingAndReconciliation'
import General from './sections/General'
import TravellerGettingStarted from './sections/TravellerGettingStarted'
import TravellerBookingAFlight from './sections/TravellerBookingAFlight'
import TravellerLoyalty from './sections/TravellerLoyalty'
import TravellerPaymentAndInvoicing from './sections/TravellerPaymentAndInvoicing'
import TravellerGamification from './sections/TravellerGamification'
import FaqSidebar from './FaqSidebar'

const faqSections = [
  {
    title: 'Administrator',
    items: [
      { id: 'admin-getting-started', sidebarTitle: 'Getting started', Component: AdminGettingStarted },
      { id: 'admin-traveller-management', sidebarTitle: 'Traveller Management', Component: TravellerManagement },
      { id: 'admin-travel-policies', sidebarTitle: 'Travel policies', Component: TravelPolicies },
      { id: 'admin-travel-approvals', sidebarTitle: 'Travel approvals', Component: TravelApprovals },
      { id: 'admin-booking-management', sidebarTitle: 'Booking management', Component: BookingManagement },
      { id: 'admin-gamification', sidebarTitle: 'Gamification', Component: AdminGamification },
      { id: 'admin-loyalty-programs', sidebarTitle: 'Loyalty programs', Component: LoyaltyPrograms },
      { id: 'admin-reporting', sidebarTitle: 'Reporting and reconciliation', Component: ReportingAndReconciliation },
      { id: 'admin-general', sidebarTitle: 'General', Component: General },
    ],
  },
  {
    title: 'Traveller',
    items: [
      { id: 'traveller-getting-started', sidebarTitle: 'Getting started', Component: TravellerGettingStarted },
      { id: 'traveller-booking-flight', sidebarTitle: 'Booking a flight', Component: TravellerBookingAFlight },
      { id: 'traveller-loyalty', sidebarTitle: 'Loyalty', Component: TravellerLoyalty },
      { id: 'traveller-payment-invoicing', sidebarTitle: 'Payment and invoicing', Component: TravellerPaymentAndInvoicing },
      { id: 'traveller-gamification', sidebarTitle: 'Gamification', Component: TravellerGamification },
    ],
  },
]

export default function BusinessTravellerFaqPage() {
  return (
    <LayoutContainer size="md">
      <Pane>
        <FaqSidebar sections={faqSections}>
          <Group direction="vertical" gap={16}>
            <Heading variant="heading2">Frequently Asked Questions</Heading>
            <Group direction="vertical" gap={28}>
              {faqSections.map((section) => (
                <React.Fragment key={section.title}>
                  <Heading variant="heading3">{section.title}</Heading>
                  {section.items.map((item) => (
                    <React.Fragment key={item.id}>
                      <div id={item.id}>
                        <item.Component />
                      </div>
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </Group>
          </Group>
        </FaqSidebar>
      </Pane>
    </LayoutContainer>
  )
}
